import React from "react";
import {
  Grid,
  Stack,
  Typography,
  Box,
  Card,
  CardContent,
  Icon,
} from "@mui/material";
import vision from "./../images/vission.jpg";
import mision from "./../images/mission.jpg";
import "./Aboutus.css";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import useMediaQuery from "@mui/material/useMediaQuery";

const VisionAndMision = () => {
  const vMediaQuery = useMediaQuery("(max-width:600px)");

  const visionStyle = {
    display: "flex",
    margin: "auto",
    padding: vMediaQuery ? "0px" : "16px",
    minHeight: "40vh",
    backgroundColor: "#f2fcf5",
    border: "1px solid green",
    boxShadow: "12px 12px rgba(165, 181, 169, 0.6)", // Dark green shadow effect
  };

  const missionStyle = {
    display: "flex",
    margin: "auto",
    padding: vMediaQuery ? "0px" : "16px",
    minHeight: "40vh",
    backgroundColor: "#f5faff",
    border: "1px solid #357ec7",
    boxShadow: "12px 12px rgba(152, 183, 214, 0.6)", // Blue shadow effect
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        padding: vMediaQuery ? "30px" : "80px 140px",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Grid container spacing={5}>
        <Grid item xs={12} md={6} lg={6}>
          <Card className="vmCards" style={visionStyle}>
            <CardContent>
              <Icon
                style={{ fontSize: "140px", color: "blue", float: "right" }}
              >
                {/* Replace 'icon_name' with the actual icon name */}
                <div className="vision-contanier">
                  <img className="vision" alt="vision" src={vision} />
                </div>
              </Icon>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ fontWeight: 600, color: "green",  fontFamily: "EB Garamond", }}
              >
                Our Vision
              </Typography>
              <Typography
                variant={vMediaQuery ? "body2" : "body1"}
                color="textSecondary"
              >
                We aim at being the most<strong> progressive company</strong>{" "}
                empowering customers with business and technology solutions
                providing specialized services through our{" "}
                <strong>collective wisdom</strong> and{" "}
                <strong>sustainable processes.</strong>
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <Card className="vmCards" style={missionStyle}>
            <CardContent>
              <Icon
                style={{ fontSize: "140px", color: "blue", float: "right" }}
              >
                {/* Replace 'icon_name' with the actual icon name */}
                <div className="vision-contanier">
                  <img className="vision" alt="vision" src={mision} />
                </div>
              </Icon>
              <Typography
                gutterBottom
                variant="h5"
                component="div"
                sx={{ fontWeight: 600, color: "#357ec7",  fontFamily: "EB Garamond", }}
              >
                Our Mision
              </Typography>
              <Typography
                variant={vMediaQuery ? "body2" : "body1"}
                color="textSecondary"
              >
                Our roadmap starts with our mission. It declares our purpose as
                a company and serves as the standard against which we weigh our
                actions and decisions.
              </Typography>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <Stack direction={"row"} spacing={1}>
                    <ArrowRightAltIcon />

                    <Typography variant={vMediaQuery ? "body2" : "body1"}>
                      To <strong>create</strong> value and make a difference{" "}
                    </Typography>
                  </Stack>
                  <Stack direction={"row"} spacing={1}>
                    <ArrowRightAltIcon />

                    <Typography variant={vMediaQuery ? "body2" : "body1"}>
                      To <strong>inspire</strong> all those with whom we connect{" "}
                    </Typography>
                  </Stack>
                  <Stack direction={"row"} spacing={1}>
                    <ArrowRightAltIcon />

                    <Typography variant={vMediaQuery ? "body2" : "body1"}>
                      To <strong>provide</strong> an undeniable customer service
                      experience{" "}
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default VisionAndMision;
